"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createPerson = void 0;
var _utils = require("../utils");
var _personLite = _interopRequireDefault(require("./person-lite"));
var _seo = _interopRequireDefault(require("./seo"));
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _person = _interopRequireDefault(require("../utils/rich-text-factories/person"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createPerson = function createPerson(_ref) {
  var sys = _ref.sys,
    fields = _ref.fields;
  var publicationContent = (0, _utils.getProp)(fields, 'publications');
  var publications = publicationContent ? (0, _processRichText["default"])({
    document: publicationContent,
    factories: _person["default"]
  }) : null;
  var bioContent = (0, _utils.getProp)(fields, 'bio');
  var bio = bioContent ? (0, _processRichText["default"])({
    document: bioContent,
    factories: _person["default"]
  }) : null;
  return _objectSpread(_objectSpread({}, (0, _personLite["default"])({
    sys: sys,
    fields: fields
  })), {}, {
    seo: (0, _seo["default"])({
      sys: sys,
      fields: fields
    }),
    bio: bio,
    publications: publications
  });
};
exports.createPerson = createPerson;
var personFactory = function personFactory(items) {
  return createPerson(items.shift());
};
var _default = personFactory;
exports["default"] = _default;